module.exports = __webpack_public_path__ + "img/bt-2-on.7a8d8d12.png";